import React, { useState, useEffect, useRef } from 'react';
import './FontPicker.css';

export default function FontPicker(props) {

    const { fonts, font, setFont } = props;
    const [ show, setShow ] = useState(false);
    const [ selected, setSelected ] = useState(font);
    const pickerRef = useRef(null);

    const handleFontSelect = (e) => {
        setFont(e.target.id);
        setShow(false);
    };

    useEffect(() => {
        if(font) {
            const first = font.slice(font.indexOf('\'') === 0);
            const second = first.substr(0, first.indexOf('\''));
            setSelected(second);
        }
    },[font]);

    useEffect(() => {

        const handleClick = (e) => {
            if (pickerRef.current && !pickerRef.current.contains(e.target)) {
                setShow(false);
            };
        };

        document.addEventListener('click', handleClick);
        return () => {
            window.removeEventListener('click',handleClick);
        };
    },[]);

    return (
        <div className='font-picker-select' onClick={() => setShow(!show)} style={{fontFamily: font}} ref={pickerRef}>
            {selected}
            {show && 
                <div className='font-picker-list'>
                    {fonts.map(font => (
                        <p key={font.id} id={font.font} className='font-picker-font' style={{fontFamily: font.font}} onClick={(e) => handleFontSelect(e)}>{font.name}</p>
                    ))}
                </div>
            }
        </div>
    );
};